'use strict';

exports.__esModule = true;
exports.convertSiteLevelMetaTags = convertSiteLevelMetaTags;

var _TagTypes = require('../types/TagTypes');

var _Props = require('../types/Props');

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function convertSiteLevelMetaTags(payload) {
  var result = {
    tags: []
  };

  if (payload && Array.isArray(payload)) {
    result.tags = payload.reduce(function (acc, curr) {
      if (curr && curr.name && curr.value) {
        var _props;

        return acc.concat({
          type: _TagTypes.TAG_TYPES.META,
          props: (_props = {}, _props[curr.name.startsWith('og:') ? _Props2.default.PROPERTY : _Props2.default.NAME] = curr.name, _props.content = curr.value, _props)
        });
      }
      return acc;
    }, result.tags);
  }

  return result;
}